import { Controller } from "@hotwired/stimulus"

// Slide-over drawer that hosts the catalog entry form (loaded lazily into a Turbo
// frame). Opening is triggered by the new/edit links; closing happens on the close
// button, the backdrop, Escape, or automatically when a successful save streams a
// fresh (closed) drawer in to replace this one.
export default class extends Controller {
  static targets = ["panel", "backdrop"]

  connect() {
    this.boundKeydown = this.onKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
  }

  // The keydown listener is registered on `document`, not through a Stimulus action,
  // so an error in here escapes Stimulus's handler and surfaces as an uncaught one.
  // A page that declares the controller without rendering a drawer must stay silent.
  get ready() {
    return this.hasBackdropTarget && this.hasPanelTarget
  }

  open() {
    if (!this.ready) return

    this.backdropTarget.classList.remove("hidden")
    this.panelTarget.classList.remove("translate-x-full")
  }

  close() {
    if (!this.ready) return

    this.backdropTarget.classList.add("hidden")
    this.panelTarget.classList.add("translate-x-full")
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close()
  }
}
